import { InsightVariantType } from '../../../../../../components/insight/types/insightVariantType';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { ButtonSizeType, ButtonVariantType, LinkVariantType, TextVariantType, } from '../../variants';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [InsightVariantType.REGULAR]: {
            rootContainer: {
                width: '100%',
                padding_left: FOUNDATIONS.spacing_250,
                padding_right: FOUNDATIONS.spacing_250,
                display: 'flex',
                flex_direction: 'row',
                background_color: FOUNDATIONS.color_neutral_bg_opacity_00,
                gap: FOUNDATIONS.spacing_200,
            },
            decorativeContainer: {
                display: 'flex',
                flex_direction: 'row',
            },
            decorativeBarContainer: {
                width: FOUNDATIONS.spacing_100,
                background_color: FOUNDATIONS.color_product_wealth_bg_50,
            },
            informationActionsContainer: {
                width: '100%',
                display: 'flex',
                flex_direction: 'column',
                align_items: 'start',
                gap: FOUNDATIONS.spacing_250,
            },
            informationContainer: {
                width: '100%',
                display: 'flex',
                flex_direction: 'column',
                gap: FOUNDATIONS.spacing_100,
            },
            icon: {
                width: FOUNDATIONS.size_350,
                height: FOUNDATIONS.size_350,
                color: FOUNDATIONS.color_comp_content_insight_icon,
            },
            title: {
                font_variant: TextVariantType.FONT_PARAGRAPH_50,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_neutral_font_50,
            },
            subtitle: {
                font_variant: TextVariantType.FONT_PARAGRAPH_350,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_neutral_font_50,
            },
            action: {
                variant: ButtonVariantType.SECONDARY,
                size: ButtonSizeType.SMALL,
            },
            link: {
                variant: LinkVariantType.SECONDARY,
            },
        },
    };
};
//# sourceMappingURL=regular.js.map